<template>
  <div class="apple-pay-main">
    <div class="applepay-button-fill">
      <button
        class="applepay-button"
        type="button"
        :disabled="disablePaymentButton"
        @click="startPayment"
        :class="{ disabled: disablePaymentButton }"
        aria-label="Apple Pay"
      ></button>
    </div>
    <div class="apple-pay-main-button">
      <div class="applepay-main-in">
        <button
          style="display:none"
          @click="_setButtonClickListener"
          id="ckoApplePay"
          class="apple-pay-button-redsys apple-pay-button-text-palin apple-pay-button-black-redsys"
          lang="en"
        ></button>
        <p style="display:none" id="ckoApplePayError">
          ApplePay is not available in this environment.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
const NO_QR = "NO QR";
import applePayMixinRedsys from "@/mixins/payment/applePayMixinRedsys";
import RedsysMixin from "@/mixins/payment/RedsysMixin";
import paymentsMixin from "@/mixins/payment/paymentsMixin";

export default {
  name: "applepay-redsys",
  mixins: [applePayMixinRedsys, RedsysMixin, paymentsMixin],
  props: [
    "totalPrice",
    "disablePaymentButton",
    "unpaidTotalPrice",
    "tableQR",
    "dividePayment"
  ],
  data() {
    return {
      loading: false,
      dialogLoader: false,
      paymentType: "products",
      paymentMethod: "applepay",
      showApplePayPayBtn: false,
      applePayContainerEnable: false
    };
  },
  computed: {
    cart() {
      return this.$store.state.cart;
    }
  },
  methods: {
    startPayment() {
      if (!this.tableQR || this.tableQR === NO_QR) {
        this.checkQR = true;
        this.$emit("checkQRUpdate", this.checkQR);
        return;
      }
      this.onApplePayLoaded();
    }
  }
};
</script>
